export const ENDPOINT_TYPES = {
    SLACK_CHANNEL: 'slack_channel',
    SLACK_USER: 'slack_user',
    WEBHOOK: 'webhook',
    PHONE: 'phone',
    MS_TEAMS_CHANNEL: 'ms_teams_channel',
    MS_TEAMS_USER: 'ms_teams_user',
    TELEGRAM_CHAT: 'telegram_chat',
};
//# sourceMappingURL=channel-endpoint.js.map